module.exports = __webpack_public_path__ + "img/point-free-3.6f11395e.png";